import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4cb5e21f")

_pushScopeId("data-v-4cb5e21f")
const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-ai-end p-formgrid p-grid p-m-2"
}
const _hoisted_2 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "hint" }
const _hoisted_6 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "label ",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "hint" }
const _hoisted_10 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "owner ",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field p-col-6 p-mb-6" }
const _hoisted_14 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-field p-col-12 p-mb-12" }
const _hoisted_16 = {
  for: "keywords",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "p-field p-col-12 p-mb-12" }
const _hoisted_18 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_19 = {
  key: 0,
  class: "p-error p-grid p-m-2"
}
const _hoisted_20 = { class: "p-field p-col-12 p-mb-12" }
const _hoisted_21 = {
  for: "benchmarks",
  class: "kn-material-input-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Editor = _resolveComponent("Editor")
  const _component_Button = _resolveComponent("Button")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_ctx.selectedFunction)
    ? (_openBlock(), _createBlock("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: "kn-material-input",
              modelValue: _ctx.selectedFunction.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFunction.name = $event)),
              modelModifiers: { trim: true },
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.functionsCatalog.functionName')), 1),
            _createVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('managers.functionsCatalog.functionNameHint')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, [
            _createVNode(_component_InputText, {
              id: "label ",
              class: "kn-material-input",
              modelValue: _ctx.selectedFunction.label,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedFunction.label = $event)),
              modelModifiers: { trim: true },
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.label')), 1),
            _createVNode("small", _hoisted_9, _toDisplayString(_ctx.$t('managers.functionsCatalog.functionLabelHint')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_InputText, {
              id: "owner ",
              class: "kn-material-input",
              modelValue: _ctx.selectedFunction.owner,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedFunction.owner = $event)),
              modelModifiers: { trim: true },
              disabled: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.owner')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.type')), 1),
            _createVNode(_component_Dropdown, {
              id: "type",
              class: "kn-material-input",
              modelValue: _ctx.selectedFunction.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedFunction.type = $event)),
              options: _ctx.functionTypes,
              optionLabel: "valueCd",
              optionValue: "valueCd",
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.functionsCatalog.keywords')), 1),
            _createVNode(_component_Chips, {
              id: "keywords",
              class: "p-inputtext-sm",
              multiple: true,
              modelValue: _ctx.selectedFunction.tags,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedFunction.tags = $event)),
              disabled: _ctx.readonly,
              placeholder: _ctx.$t('managers.functionsCatalog.keywords')
            }, null, 8, ["modelValue", "disabled", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Accordion, null, {
            default: _withId(() => [
              _createVNode(_component_AccordionTab, {
                header: _ctx.$t('common.description') + ' *'
              }, {
                default: _withId(() => [
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('common.description')) + " *", 1),
                  (_ctx.showDescriptionSource)
                    ? (_openBlock(), _createBlock(_component_Textarea, {
                        key: 0,
                        modelValue: _ctx.selectedFunction.description,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedFunction.description = $event)),
                        style: _ctx.functionsCatalogGeneralTabDescriptor.editor.style,
                        class: {
                            'p-invalid': _ctx.selectedFunction.description.length === 0 && _ctx.descriptionDirty
                        },
                        readonly: _ctx.readonly,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.descriptionDirty = true)),
                        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.descriptionDirty = true))
                      }, null, 8, ["modelValue", "style", "class", "readonly"]))
                    : (_openBlock(), _createBlock(_component_Editor, {
                        key: 1,
                        id: "description",
                        editorStyle: _ctx.functionsCatalogGeneralTabDescriptor.editor.style,
                        modelValue: _ctx.selectedFunction.description,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedFunction.description = $event)),
                        class: {
                            'p-invalid': _ctx.selectedFunction.description.length === 0 && _ctx.descriptionDirty
                        },
                        readonly: _ctx.readonly,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.descriptionDirty = true)),
                        onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.descriptionDirty = true))
                      }, null, 8, ["editorStyle", "modelValue", "class", "readonly"])),
                  _createVNode(_component_Button, {
                    class: "editor-switch-button",
                    icon: "pi pi-bars",
                    label: _ctx.showDescriptionSource ? 'wysiwyg' : _ctx.$t('common.source'),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDescriptionSource = !_ctx.showDescriptionSource))
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }),
          (_ctx.selectedFunction.description.length === 0 && _ctx.descriptionDirty)
            ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.description') })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_Accordion, null, {
            default: _withId(() => [
              _createVNode(_component_AccordionTab, {
                header: _ctx.$t('managers.functionsCatalog.benchmarks')
              }, {
                default: _withId(() => [
                  _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('managers.functionsCatalog.benchmarks')), 1),
                  (_ctx.showBenchmarksSource)
                    ? (_openBlock(), _createBlock(_component_Textarea, {
                        key: 0,
                        modelValue: _ctx.selectedFunction.benchmark,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectedFunction.benchmark = $event)),
                        style: _ctx.functionsCatalogGeneralTabDescriptor.editor.style,
                        readonly: _ctx.readonly
                      }, null, 8, ["modelValue", "style", "readonly"]))
                    : (_openBlock(), _createBlock(_component_Editor, {
                        key: 1,
                        id: "benchmarks",
                        editorStyle: _ctx.functionsCatalogGeneralTabDescriptor.editor.style,
                        modelValue: _ctx.selectedFunction.benchmark,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedFunction.benchmark = $event)),
                        readonly: _ctx.readonly
                      }, null, 8, ["editorStyle", "modelValue", "readonly"])),
                  _createVNode(_component_Button, {
                    class: "editor-switch-button",
                    icon: "pi pi-bars",
                    label: _ctx.showBenchmarksSource ? 'wysiwyg' : _ctx.$t('common.source'),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showBenchmarksSource = !_ctx.showBenchmarksSource))
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
})